import * as React from 'react';

import { SVGProps } from '../../types';

export const IconInformationSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    focusable="false"
    fill="currentColor"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.75 16a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-1.5a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h1.5zM18 11a1.5 1.5 0 110 3 1.5 1.5 0 010-3z" />
  </svg>
);
